type CanvasInternalProps = {
};

type CanvasPropsValues = {
  '': CanvasInternalProps;
};

const propValues: CanvasPropsValues = {
  '': {
  },
};

const getProps = (type: string): CanvasInternalProps => {
  const values: CanvasInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
